enum PersonaTheme {
    Celestial = "Celestial",
    RetroY2K = "Retro Y2K",
    Brat = "Brat"
}

export {PersonaTheme};